module.exports = __webpack_public_path__ + "static/img/tccMLogo.f31a00a6.png";